import i18n from 'src/i18n/index.js';
import { formatCurrency } from 'src/utils/format';
import PaymentTerm from 'src/models/paymentTerm.js';

class PaymentDetails {
  constructor(params) {
    this.excessLimit = params.excessLimit;

    this.ibanReceivedByInsured = params.ibanReceivedByInsured;
    this.hasIbanReceivedByInsured = !!params.ibanReceivedByInsured;

    this.ibanPayedByInsured = params.ibanPayedByInsured ? params.ibanPayedByInsured : '';
    this.ibanExcess = params.ibanExcess;

    this.paymentMethod = new PaymentMethod(params.paymentMethod, 'premium');
    this.paymentMethodExcess = new PaymentMethod(params.paymentMethodExcess, 'excess', this.excessLimit);
    this.paymentTerm = new PaymentTerm(params.paymentTerm, params.paymentTermDiscounts, params.paymentTermIsMutable);

    this.hasMandatoryDirectDebit = params.hasMandatoryDirectDebit;
    this.hasAgreementEnded = params.hasAgreementEnded;

    return this;
  }
}

export class PaymentMethod {
  constructor(params, paymentType, excessLimit = 0) {
    this.method = params;
    this.isiDeal = params === 'iDeal';
    this.isDirectDebit = params === 'DirectDebit';
    this.isMail = params === 'Mail';
    this.isViaEmployer = params === 'BOR';
    this.isViaIntermediary = params === 'TPS';
    this.isPaidByCustomer = !this.isViaEmployer && !this.isViaIntermediary;

    if (!paymentType) return this;

    if (paymentType === 'premium') {
      this.path = `payment-details.${paymentType}-${params}`;
    } else {
      this.paymentTypeLabelPath = `payment-details.${paymentType}-${params}`;
      this.excessLimitLabel = i18n.global.t('payment-details.excess-limit', {
        excessLimit: formatCurrency(excessLimit),
      });
    }
    return this;
  }
}

export { PaymentDetails as default };
